var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.753.61a2.417 2.417 0 0 1 2.405 2.412 7.23 7.23 0 0 0 .364 2.272c.28.87.05 1.81-.594 2.445l-.82.82a10.025 10.025 0 0 0 2.81 2.81l.816-.816c.449-.45 1.07-.71 1.706-.71.26 0 .517.042.754.122.729.24 1.487.36 2.269.36a2.416 2.416 0 0 1 2.403 2.41v2.715a2.416 2.416 0 0 1-2.41 2.406C7.277 17.856.622 11.202.621 3.016A2.417 2.417 0 0 1 3.03.61h2.722zM3.03 2.244a.779.779 0 0 0-.777.777v.003c.001 7.29 5.912 13.2 13.203 13.2h.002a.777.777 0 0 0 .776-.776v-2.712a.777.777 0 0 0-.776-.777h-.008c-.94 0-1.873-.149-2.766-.442a.771.771 0 0 0-.792.187l-1.708 1.709a11.768 11.768 0 0 1-5.119-5.119l1.708-1.707a.782.782 0 0 0 .195-.794 8.826 8.826 0 0 1-.443-2.772.779.779 0 0 0-.776-.777z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f35ea668.svg";
export { ForwardRef as ReactComponent };